import React from 'react';

import Typed from 'typed.js';

import Headline from 'src/components/CE/Headline';
import objectWatchPolyfill from 'src/helpers/objectWatch.js'; // eslint-disable-line

// import custom build terminal-in-react
import TerminalInReact from '../../../../../vendor/build/terminal-in-react/terminal';

import '../../../../../vendor/build/terminal-in-react/Bar.css';
import '../../../../../vendor/build/terminal-in-react/Terminal.css';

const typeText = (strings, options) => {
  let el = null;
  let typer = null;
  const defaultOptions = {
    typeSpeed: 40,
    backSpeed: 20,
  };
  const extraOptions = options || {};
  return (args, print, runCommand) => {
    if (typer) {
      typer.reset();
      typer.start();
    } else {
      typer = new Typed(
        { tagName: 'none' },
        {
          strings,
          ...defaultOptions,
          ...extraOptions,
          preStringTyped: (arrayPos, self) => {
            if (!el) {
              el = self.el;
              el.watch(
                'innerHTML',
                (id, oldval, newval) =>
                  newval && runCommand(`edit-line ${newval}`),
              );
            }
          },
          onComplete: () => {
            el.unwatch();
            typer.destroy();
            if (extraOptions.onComplete) {
              extraOptions.onComplete();
            }
          },
        },
      );
    }
    return null;
  };
};

class Terminal extends React.Component {
  render() {
    const msg =
      typeof window !== 'undefined' && window.innerWidth < 440
        ? `                    o
     ###         \` /_\\ '
    (o o)       - (o o) -
ooO--(_)--Ooo-ooO--(_)--Ooo

Einfach 'help' eingeben und ENTER drücken...`
        : `                    o
     ###         \` /_\\ '         ###
    (o o)       - (o o) -       (o o)
ooO--(_)--Ooo-ooO--(_)--Ooo-ooO--(_)--Ooo

Einfach 'help' eingeben und ENTER drücken...`;
    return (
      <div className="ce ce-terminal">
        <Headline
          className="text-center"
          subHeadline={<Headline>Probier's mal per Konsole</Headline>}
        >
          Try to be nördy
        </Headline>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TerminalInReact
            color="white"
            backgroundColor="#282828"
            barColor="#383838"
            prompt="white"
            style={{ fontWeight: '500', fontSize: '1rem' }}
            commands={{
              fuf: typeText([
                'Moin^1000, wir sind `🤸‍`♀️`🤸‍``🤸‍`',
                'Moin, wir sind Fröhlich ∧ Frei^1000. Schön, dass du da bist `🎉``🎉``🎉`^1000',
                'Wir entwickeln Software für Dich, also wenn Du da was benötigst...^1000 Melde Dich gerne bei uns!',
              ]),
              bui: typeText(['Pflooooop... `🍻`']),
              osterei: typeText([
                'Das `🥚` Easteregg `🥚` musst Du Dir verdienen... `💸`^500 BEREIT?!^500 Na dann los!',
                'Was ist unser absolutes Lieblingstier? `🤔`^3000\n\n`🔍` Das Internet ' +
                  'schneidet ihm gerne lustige Frisuren...^5000',
                'Was ist unser absolutes Lieblingstier? `🤔`\n\n`🔍` Keine `🐈`...^2000 Kein `🐩`...^2000 Kein `🐑`...^3000',
                "Was ist unser absolutes Lieblingstier? `🤔`\n\n`🔍` Es `☔`SPUCKT`☔`^4000 Versuch's mit ^1000l^1000*^1000m^1000* ?!^2000",
                'Was ist unser absolutes Lieblingstier? `🤔`\n\n`‼` OKAY,^500 `👉` lama `👈` it is `😂` `😋` `😎`',
              ]),
              lama: typeText(
                ['Absolut richtig `🙏` `👏` `✊`^500 Viel Spass!^500'],
                { onComplete: () => (window.location = '/lamas/') },
              ),
            }}
            descriptions={{
              color: false,
              clear: false,
              'edit-line': false,
              echo: false,
              show: false,
              help: 'verfügbare Komandos auflisten',
              // custom
              fuf: 'etwas über Fröhlich ∧ Frei',
              bui: 'eine Bier öffnen',
              osterei: 'löse ein Rätsel',
              lama: false,
            }}
            msg={msg}
            watchConsoleLogging={false}
          />
        </div>
      </div>
    );
  }
}

export default Terminal;
